module.exports = __webpack_public_path__ + "media/03-Gestionar-articulos.fbb7e414.mp4";